export default (el) => {
  const elStyles = getComputedStyle(el);
  const elHeight = el.offsetHeight
    + parseFloat(elStyles.marginTop)
    + parseFloat(elStyles.marginBottom);
  const vpHeight = el.parentNode.offsetHeight;
  const rect = el.getBoundingClientRect();
  return Math.max(
    0,
    rect.top > 0
      ? Math.min(elHeight, vpHeight - rect.top)
      : Math.min(rect.bottom, vpHeight),
  );
};
